import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { FileUpload } from 'primereact/fileupload';
import { couponsAPI } from '../../services/couponService';

const StudentForm = ({
  visible,
  onHide,
  editingStudent,
  studentForm,
  setStudentForm,
  classes,
  sections,
  loadSections,
  handleSaveStudent,
  convertToBase64,
  toast
}) => {
  const [coupons, setCoupons] = useState([]);
   useEffect(() => {
      if (visible) {
        loadCoupons();
      }
    }, [visible]);
  
   const loadCoupons = async () => {
      try {
        const res = await couponsAPI.getUnUsedCoupons();
        const couponsData = res?.data?.coupons || [];
        setCoupons(couponsData);
      } catch (err) {
        console.error('loadCoupons error', err);
      }
    };
  return (
    <Dialog header={editingStudent ? 'Edit Student' : 'Add New Student'} visible={visible} onHide={onHide} style={{ width: '900px' }}
      footer={
        <div className="flex justify-between items-center mt-4">
          <Button label="Cancel" icon="pi pi-times" onClick={onHide} className="bg-black text-white rounded-lg px-4 py-2 hover:bg-gray-900 transition-all" />
          <Button label={editingStudent ? 'Update Student' : 'Create Student'} icon="pi pi-check" onClick={handleSaveStudent} className="px-6 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 font-medium shadow-lg hover:shadow-xl" />
        </div>
      }
      className="rounded-2xl"
    >
      <div className="space-y-6 p-2">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-800">Full Name *</label>
            <InputText value={studentForm.firstName} onChange={(e) => setStudentForm({ ...studentForm, firstName: e.target.value })}
              required placeholder="Enter first name" className="w-full p-3 border border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 bg-white shadow-sm" />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 mb-2">Coupon (Optional)</label>
           
              <Dropdown value={studentForm.couponId} options={coupons.map(c => ({ label: `${c.code} - ${c.feeType} - ${c.discountPct}%`, value: c.id }))}
                onChange={(e) => setStudentForm({ ...studentForm, couponId: e.value })} placeholder="Select coupon" className="w-full border border-gray-200 rounded-lg"
                filter filterPlaceholder="Search by code, fee type, or discount" showClear />
            
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-800">Admission Number *</label>
            <InputText value={studentForm.admissionNumber} readOnly
              required placeholder="Enter admission number" className="w-full p-3 border border-gray-200 rounded-lg focus:border-green-500 focus:ring-2 focus:ring-green-200 transition-all duration-200 bg-white shadow-sm" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-800">Date of Birth</label>
            <Calendar value={studentForm.dateOfBirth} onChange={(e) => setStudentForm({ ...studentForm, dateOfBirth: e.value })} showIcon
              className="w-full text-sm border border-gray-200 rounded-lg" panelClassName="border border-gray-200 rounded-lg shadow-lg" showClear
              dateFormat="dd-mm-yy" inputClassName="border-none focus:ring-0" />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-800"> Gender</label>
            <Dropdown value={studentForm.gender}
              options={[
                { label: 'Male', value: 'male' },
                { label: 'Female', value: 'female' },
                { label: 'Other', value: 'other' }
              ]}
              onChange={(e) => setStudentForm({ ...studentForm, gender: e.value })} placeholder="Select gender" className="w-full text-sm border border-gray-200 rounded-lg" panelClassName="border border-gray-200 rounded-lg shadow-lg" showClear />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-800">Blood Group</label>
            <Dropdown value={studentForm.bloodGroup}
              options={[
                { label: 'A+', value: 'A+' },
                { label: 'A-', value: 'A-' },
                { label: 'B+', value: 'B+' },
                { label: 'B-', value: 'B-' },
                { label: 'AB+', value: 'AB+' },
                { label: 'AB-', value: 'AB-' },
                { label: 'O+', value: 'O+' },
                { label: 'O-', value: 'O-' }
              ]}
              onChange={(e) => setStudentForm({ ...studentForm, bloodGroup: e.value })} placeholder="Select blood group"
              className="w-full text-sm border border-gray-200 rounded-lg" panelClassName="border border-gray-200 rounded-lg shadow-lg" showClear />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-800">Class</label>
            <Dropdown value={studentForm.classId} options={classes.map(c => ({ label: c.name || c.className, value: c.id }))}
              onChange={(e) => {
                setStudentForm({ ...studentForm, classId: e.value, sectionId: '' });
                loadSections(e.value);
              }}
              placeholder="Select class" className="w-full text-sm border border-gray-200 rounded-lg" panelClassName="border border-gray-200 rounded-lg shadow-lg" showClear />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-800">Section</label>
            <Dropdown value={studentForm.sectionId} options={sections.map(s => ({ label: s.name || s.section_name, value: s.id }))}
              onChange={(e) => setStudentForm({ ...studentForm, sectionId: e.value })} placeholder="Select section" disabled={!studentForm.classId}
              className="w-full text-sm border border-gray-200 rounded-lg" panelClassName="border border-gray-200 rounded-lg shadow-lg" showClear />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-800">Admission Date</label>
            <Calendar value={studentForm.admissionDate} onChange={(e) => setStudentForm({ ...studentForm, admissionDate: e.value })} showIcon dateFormat="dd-mm-yy" className="w-full text-sm border border-gray-200 rounded-lg" style={{ width: "260px" }}  />
          </div>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-semibold text-gray-800">Address</label>
          <InputTextarea value={studentForm.parentAddress} readOnly
            required style={{ width: "400px", height: "130px" }} />
          
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">Student Photo </label>
          <FileUpload name="photo" accept="image/*" maxFileSize={1000000}
            onSelect={async (e) => {
              const file = e.files[0];
              try {
                const base64 = await convertToBase64(file);
                setStudentForm({ ...studentForm, photoUrl: base64 });
              } catch (error) {
                console.error('Error converting file to base64:', error);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to process image' });
              }
            }}
            onRemove={() => setStudentForm({ ...studentForm, image: null })}
            emptyTemplate={<p className="m-0">Drag and drop student photo here or click to choose.</p>}
            chooseLabel="Choose Photo" uploadLabel="Upload" cancelLabel="Cancel" className="w-full" />
        </div>
      </div>
    </Dialog>
  );
};

export default StudentForm;
